var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" 后台数据访问 "),_c('el-button',{on:{"click":_vm.mytest}},[_vm._v("点击我试下")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }